var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalevent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33325V6.66659H8.33333C6.5 6.66659 5 8.16658 5 9.99992V33.3333C5 35.1666 6.5 36.6666 8.33333 36.6666H31.6667C33.5 36.6666 35 35.1666 35 33.3333V9.99992C35 8.16658 33.5 6.66659 31.6667 6.66659H30V3.33325H26.6667V6.66659H13.3333V3.33325H10ZM8.33333 14.9999H31.6667V33.3333H8.33333V14.9999Z",
    fill: "#0D263C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 30.4999L22.5 27.9999L18.3333 30.4999L19.3333 25.9999L15.8333 22.9999L20.5 22.6666L22.3333 18.3333L24.1667 22.6666L28.8333 23.1666L25.3333 26.1666L26.5 30.4999Z",
    fill: "#0D263C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalevent);
export default __webpack_public_path__ + "static/media/totalevent.ed39194afc6323298254d99c393edc00.svg";
export { ForwardRef as ReactComponent };